export const changeMessageFromHelpSideContent = (
  idatendimento,
  textMessage,
  contactId,
  infoUsers
) => {
  return {
    type: "CHANGE_MESSAGE_FROM_HELP_SIDE_CONTENT",
    idatendimento,
    textMessage,
    contactId,
    infoUsers,
  };
};
